import { Component, OnInit, ViewChild} from '@angular/core';
import { AccountDetailsService } from '../services/account-details.service';
import { LoginService } from '../services/login.service';
import { AccountDetails } from '../models/AccountDetail';
import { AccountDeviceModel } from '../models/AccountDevicesModel';
import { CurrentAccount } from '../models/AccountModel';
import { UserInfoModel } from '../models/UserInfoModel';
import { CustomerContactMethodModel } from '../models/CustomerContactMethodModel';
import { AlarmsService } from '../services/alarms-service.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {
  Router
} from '@angular/router';
import { DxPopupModule, DxButtonModule, DxTemplateModule } from 'devextreme-angular';

@Component({
  selector: 'app-contact-container',
  templateUrl: './contact-container.component.html',
  styleUrls: ['./contact-container.component.css']
})
export class ContactContainerComponent implements OnInit {
  acctDetails: AccountDetails;
  customerInfo: UserInfoModel;
  accountsWithDevices: AccountDeviceModel;
  currentAccount: CurrentAccount;
  model: CustomerContactMethodModel;
  oneAtATime = true;
  subscribe = false;
  account: any;
  accountId: number;
  accountEmail: string;
  accountHomePhone: string;
  accountCellPhone: string;
  accountBizPhone: string;
  accountStreetAddress: string;
  accountCityStateZip: string;
  canAddNewPhoneNumber = false;
  canAddNewEmail = false;
  addNewPhone = false;
  addNewEmail = false;
  phoneNumberType: string;
  emailType = "";
  newPhoneNumber: string;
  newEmail = "";
  phoneTypes: string[] = [];
  enableAddPhoneBtn = false;
  enableAddEmailBtn = false;
  popupVisibleEamil = false;
  popupVisiblePhone = false;
  popupVisibleHome = false;
  popupVisibleCell = false;
  popupVisibleBiz = false;
  editHome = false;
  editCell = false;
  editBiz = false;
  enableEditHomeBtn = true;
  enableEditCellBtn = true;
  enableEditBizBtn = true;
  editHomeNumber: string;
  editCellNumber: string;
  editBizNumber: string;
  editEmail = false;
  enableEditEmailBtn = true;
  alertPhoneNumber = "";
  alertEmailAddress = "";
  loading = true;
  acctIndexID: any;

  constructor(
    private loginService: LoginService,
    private accountDetailsService: AccountDetailsService,
    private router: Router,
    private alarmsService: AlarmsService,
    private spinnerService: Ng4LoadingSpinnerService
  ) { }

  ngOnInit() {
    this.getUserCOntactInfo();
  }

  getActiveAcctIndex(accts, activeAcctID) {
    var acctIDIndex = 0;

    //get correct acct based on selected active acctid
    for (var i = 0; i < accts.length; i++) {
      let acct = accts[i];
      if (acct.accountId == activeAcctID) {
        acctIDIndex = i;
        break;
      }
    }
    return acctIDIndex;
  }

  getUserCOntactInfo() {
    this.spinnerService.show();
    this.loginService.getUserContext()
      .subscribe((account) => {
        this.account = account;
        this.acctIndexID = this.getActiveAcctIndex(account.accountsWithDevices, account.activeAcctId);

        let accountsWithDevices = account.accountsWithDevices[this.acctIndexID];
        let accountDetails = this.account.accountDetails[this.acctIndexID].accountDetails;
        this.accountId = accountDetails.accountId;
        this.accountEmail = accountDetails.email;

        //get alarm phone number text
        let orgUnitId = accountsWithDevices.orgUnitId;
        let deviceId = accountsWithDevices.deviceId;
        this.getFlowAlarms(orgUnitId, deviceId);

        this.accountStreetAddress = accountDetails.address1 + (accountDetails.address2 !== null ? " " + accountDetails.address2 : "");
        this.accountCityStateZip = accountDetails.city + ", " + accountDetails.state + " " + accountDetails.zipcode;

        if (accountDetails.homePhone !== null && accountDetails.homePhone !== "") {
          this.accountHomePhone = this.formatPhoneNumber(accountDetails.homePhone);
        } else {
          this.accountHomePhone = "";
          this.phoneTypes.push("Home");
        }
        if (accountDetails.cellPhone !== null && accountDetails.cellPhone !== "") {
          this.accountCellPhone = this.formatPhoneNumber(accountDetails.cellPhone);
        } else {
          this.accountCellPhone = "";
          this.phoneTypes.push("Cell");
        }
        if (accountDetails.businessPhone !== null && accountDetails.businessPhone !== "") {
          this.accountBizPhone = this.formatPhoneNumber(accountDetails.businessPhone);
        } else {
          this.accountBizPhone = "";
          this.phoneTypes.push("Business");
        }

        this.showHideAddPhoneLink();
        this.showHideAddEmailLink();
        () => this.spinnerService.hide();
      });
  }

  getFlowAlarms(orgUnitId, deviceId) {
    this.alarmsService.getAlarms(orgUnitId, deviceId, "1")
      .subscribe((alarms) => {
        if (alarms.success){

          this.accountId = alarms.modelRet.accountId;

          if (alarms.modelRet.contactInfoText !== "" && alarms.modelRet.contactInfoText !== null) {
            this.alertPhoneNumber = this.formatPhoneNumber(alarms.modelRet.contactInfoText);
          }

          if (alarms.modelRet.contactInfoEmail !== "" && alarms.modelRet.contactInfoEmail !== null) {
            this.alertEmailAddress = alarms.modelRet.contactInfoEmail;
          }
        }
      });
  }

  removeItemFromArray(arr, what) {
    var found = arr.indexOf(what);

    while (found !== -1) {
      arr.splice(found, 1);
      found = arr.indexOf(what);
    }
  }
  validateEmail(email) {
    if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
      this.enableAddEmailBtn = true;
    }
    else {
      this.enableAddEmailBtn = false;
    }
  }
  validateEditEmail(email) {
    if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
      this.enableEditEmailBtn = true;
    }
    else {
      this.enableEditEmailBtn = false;
    }
  }
  validatePhone(phoneNumber) {
    if (/^\d{10}$/.test(phoneNumber)) {
      this.enableAddPhoneBtn = true;
    }
    else {
      this.enableAddPhoneBtn = false;
    }
  }
  validateEditPhone(phoneNumber, type) {
    if (type === 'home') {
      if (/^\d{10}$/.test(phoneNumber)) {
        this.enableEditHomeBtn = true;
      }
      else {
        this.enableEditHomeBtn = false;
      }
    }
    else if (type === 'cell') {
      if (/^\d{10}$/.test(phoneNumber)) {
        this.enableEditCellBtn = true;
      }
      else {
        this.enableEditCellBtn = false;
      }
    }
    else if (type === 'biz') {
      if (/^\d{10}$/.test(phoneNumber)) {
        this.enableEditBizBtn = true;
      }
      else {
        this.enableEditBizBtn = false;
      }
    }
  }
  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return cleaned
  }

  showHideAddEmailLink() {
    if (this.accountEmail === null || this.accountEmail === "") {
      this.canAddNewEmail = true;
    } else {
      this.canAddNewEmail = false;
    }
  }
  addNewEmailInput() {
    this.addNewEmail = true;
  }
  cancelAddNewEmailInput() {
    this.addNewEmail = false;
    this.newEmail = "";
    this.emailType = "";
    this.enableAddEmailBtn = false;
  }
  setPhoneType(val) {
    this.phoneNumberType = val;
  }
  setNewPhoneNumber(val) {
    this.newPhoneNumber = val();
  }

  saveNewPhoneNumber() {
    this.spinnerService.show();
    //empty email values of model
    this.emailType = "";
    this.newEmail = "";

    //create model
    let phoneModel = {
      AccountId: this.accountId,
      PhoneNumberType: this.phoneNumberType,
      EmailType: this.emailType,
      PhoneNumber: this.newPhoneNumber,
      Email: this.newEmail
    }

    this.accountDetailsService.updateUserContactMethods(phoneModel)
      .subscribe((res) => {
        if (res.success) {
          let local = this.loginService.getUserContextDetail();

          if (this.phoneNumberType === "Home") {
            local.accountDetails[this.acctIndexID].accountDetails.homePhone = this.newPhoneNumber;
            this.loginService.setUserContextDetail(local);
            this.accountHomePhone = this.formatPhoneNumber(this.newPhoneNumber);
            this.removeItemFromArray(this.phoneTypes, this.phoneNumberType);
          } else if (this.phoneNumberType === "Cell") {
            local.accountDetails[this.acctIndexID].accountDetails.cellPhone = this.newPhoneNumber;
            this.loginService.setUserContextDetail(local);
            this.accountCellPhone = this.formatPhoneNumber(this.newPhoneNumber);
            this.removeItemFromArray(this.phoneTypes, this.phoneNumberType);
          } else if (this.phoneNumberType === "Business") {
            local.accountDetails[this.acctIndexID].accountDetails.businessPhone = this.newPhoneNumber;
            this.loginService.setUserContextDetail(local);
            this.accountBizPhone = this.formatPhoneNumber(this.newPhoneNumber);
            this.removeItemFromArray(this.phoneTypes, this.phoneNumberType);
          }
          this.cancelAddNewPhoneInput();
          this.showHideAddPhoneLink();
          console.log('success');
        } else {
          console.log('failure');
        }
        () => this.spinnerService.hide();
      });
  }
  showHideAddPhoneLink() {
    if ((this.accountHomePhone === "" || this.accountHomePhone === null) || (this.accountCellPhone === "" || this.accountCellPhone === null) || (this.accountBizPhone === "" || this.accountBizPhone === null)) {
      this.canAddNewPhoneNumber = true;
    } else {
      this.canAddNewPhoneNumber = false;
    }
  }
  addNewPhoneInput() {
    this.addNewPhone = true;
  }
  cancelAddNewPhoneInput() {
    this.addNewPhone = false;
    this.newPhoneNumber = "";
    this.phoneNumberType = "";
    this.enableAddPhoneBtn = false;
  }

  preparePhoneNumberForSaving(phoneNumber){
    var result = phoneNumber.replace(/[- )(]/g, '');
    return result;
  }

  saveNewEmail() {
    this.spinnerService.show();
    //change this to come from selected value in dropdown when AltEmail column is added
    this.emailType = "Primary";

    //empty phone values of model
    this.phoneNumberType = "";
    this.newPhoneNumber = "";

    //create model
    let emailModel = {
      AccountId: this.accountId,
      PhoneNumberType: this.phoneNumberType,
      EmailType: this.emailType,
      PhoneNumber: this.newPhoneNumber,
      Email: this.newEmail
    }

    this.accountDetailsService.updateUserContactMethods(emailModel)
      .subscribe((res) => {
        if (res.success) {
          let local = this.loginService.getUserContextDetail();
          local.accountDetails[this.acctIndexID].accountDetails.email = this.newEmail;
          this.loginService.setUserContextDetail(local);
          this.accountEmail = this.newEmail;
          this.cancelAddNewEmailInput();
          this.showHideAddEmailLink();
          console.log('success');
        } else {
          console.log('failure');
          this.cancelAddNewEmailInput();
        }
        () => this.spinnerService.hide();
      });
  }

  removePhoneByType(type) {
    this.spinnerService.show();

    //empty email values of model
    this.emailType = "";
    this.newEmail = "";
    this.phoneNumberType = type;

    //create model
    let phoneModel = {
      AccountId: this.accountId,
      PhoneNumberType: this.phoneNumberType,
      EmailType: this.emailType,
      PhoneNumber: null,
      Email: this.newEmail
    }

    this.accountDetailsService.updateUserContactMethods(phoneModel)
      .subscribe((res) => {
        if (res.success) {
          let local = this.loginService.getUserContextDetail();

          //set the bound phone number to null by type and close the popup by type
          if (this.phoneNumberType === "Home") {
            local.accountDetails[this.acctIndexID].accountDetails.homePhone = null;
            this.loginService.setUserContextDetail(local);
            this.accountHomePhone = null;
            this.closeHomePopup();
          } else if (this.phoneNumberType === "Cell") {
            local.accountDetails[this.acctIndexID].accountDetails.cellPhone = null;
            this.loginService.setUserContextDetail(local);
            this.accountCellPhone = null;
            this.closeCellPopup();
          } else if (this.phoneNumberType === "Business") {
            local.accountDetails[this.acctIndexID].accountDetails.businessPhone = null;
            this.loginService.setUserContextDetail(local);
            this.closeBizPopup();
            this.accountBizPhone = null;
          }
          //add the removed type to the array
          this.phoneTypes.push(this.phoneNumberType);
          this.cancelAddNewPhoneInput();
          this.showHideAddPhoneLink();
          console.log('success');
        } else {
          console.log('failure');
        }
        () => this.spinnerService.hide();
      });
  }
  removeCellPhone() {
    return;
  }
  removeBizPhone() {
    return;
  }
  removeEmail() {
    () => this.spinnerService.hide();

    //change this to come from selected value in dropdown when AltEmail column is added
    this.emailType = "Primary";

    //set email to null to remove it
    this.newEmail = null;

    //empty phone values of model
    this.phoneNumberType = "";
    this.newPhoneNumber = "";

    //create model
    let emailModel = {
      AccountId: this.accountId,
      PhoneNumberType: this.phoneNumberType,
      EmailType: this.emailType,
      PhoneNumber: this.newPhoneNumber,
      Email: this.newEmail
    }

    this.accountDetailsService.updateUserContactMethods(emailModel)
      .subscribe((res) => {
        if (res.success) {
          let local = this.loginService.getUserContextDetail();
          local.accountDetails[this.acctIndexID].accountDetails.email = this.newEmail;
          this.loginService.setUserContextDetail(local);
          this.accountEmail = this.newEmail;
          this.closeEmailPopup();
          this.showHideAddEmailLink();
          console.log('success');
        } else {
          console.log('failure');
          this.cancelAddNewEmailInput();
        }
        () => this.spinnerService.hide();
      });
  }
  openEamilPopUp() {
    this.popupVisibleEamil = true;
  }
  closeEmailPopup() {
    this.popupVisibleEamil = false;
  }

  openHomePopUp() {
    this.popupVisibleHome = true;
  }
  closeHomePopup() {
    this.popupVisibleHome = false;
  }

  openCellPopUp() {
    this.popupVisibleCell = true;
  }
  closeCellPopup() {
    this.popupVisibleCell = false;
  }

  openBizPopUp() {
    this.popupVisibleBiz = true;
  }
  closeBizPopup() {
    this.popupVisibleBiz = false;
  }
  editHomePhone() {
    this.editHome = true;
    this.editHomeNumber = this.preparePhoneNumberForSaving(this.accountHomePhone);
  }
  editCellPhone() {
    this.editCell = true;
    this.editCellNumber = this.preparePhoneNumberForSaving(this.accountCellPhone);
  }
  editBizPhone() {
    this.editBiz = true;
    this.editBizNumber = this.preparePhoneNumberForSaving(this.accountBizPhone);
  }

  editPhoneByType(type) {
    this.spinnerService.show();

    //empty email values of model
    this.emailType = "";
    this.newEmail = "";
    this.phoneNumberType = type;
    let phoneModel = {};

    //create model by type
    if (this.phoneNumberType === "Home") {
      phoneModel = {
        AccountId: this.accountId,
        PhoneNumberType: this.phoneNumberType,
        EmailType: this.emailType,
        PhoneNumber: this.editHomeNumber,
        Email: this.newEmail
      }
    } else if (this.phoneNumberType === "Cell") {
      phoneModel = {
        AccountId: this.accountId,
        PhoneNumberType: this.phoneNumberType,
        EmailType: this.emailType,
        PhoneNumber: this.editCellNumber,
        Email: this.newEmail
      }
    } else if (this.phoneNumberType === "Business") {
      phoneModel = {
        AccountId: this.accountId,
        PhoneNumberType: this.phoneNumberType,
        EmailType: this.emailType,
        PhoneNumber: this.editBizNumber,
        Email: this.newEmail
      }
    }

    this.accountDetailsService.updateUserContactMethods(phoneModel)
      .subscribe((res) => {
        if (res.success) {
          let local = this.loginService.getUserContextDetail();
          if (this.phoneNumberType === "Home") {
            this.accountHomePhone = this.formatPhoneNumber(this.editHomeNumber);
            local.accountDetails[this.acctIndexID].accountDetails.homePhone = this.editHomeNumber;
            this.loginService.setUserContextDetail(local);
            this.editHome = false;
          } else if (this.phoneNumberType === "Cell") {
            this.accountCellPhone = this.formatPhoneNumber(this.editCellNumber);
            local.accountDetails[this.acctIndexID].accountDetails.cellPhone = this.editCellNumber;
            this.loginService.setUserContextDetail(local);
            this.editCell = false;
          } else if (this.phoneNumberType === "Business") {
            this.accountBizPhone = this.formatPhoneNumber(this.editBizNumber);
            local.accountDetails[this.acctIndexID].accountDetails.businessPhone = this.editBizNumber;
            this.loginService.setUserContextDetail(local);
            this.editBiz = false;
          }
          console.log('success');
        } else {
          console.log('failure');
        }
        () => this.spinnerService.hide();
      });
  }

  saveEditEmail() {
    this.spinnerService.show();

    //change this to come from selected value in dropdown when AltEmail column is added
    this.emailType = "Primary";

    //empty phone values of model
    this.phoneNumberType = "";
    this.newPhoneNumber = "";

    //create model
    let emailModel = {
      AccountId: this.accountId,
      PhoneNumberType: this.phoneNumberType,
      EmailType: this.emailType,
      PhoneNumber: this.newPhoneNumber,
      Email: this.accountEmail
    }

    this.accountDetailsService.updateUserContactMethods(emailModel)
      .subscribe((res) => {
        if (res.success) {
          this.editEmail = false;
          console.log('success');
          let local = this.loginService.getUserContextDetail();
          local.accountDetails[this.acctIndexID].accountDetails.email = this.accountEmail;
          this.loginService.setUserContextDetail(local);
        } else {
          console.log('failure');
          this.cancelAddNewEmailInput();
        }
        () => this.spinnerService.hide();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/contact-container/contact-container.component.ts